import * as React from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import Footer from "../components/footer/index";
import StepsSwitch from "../components/steps/switch/index";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);

  .stepsContainer {
    width: 100%;
  }
`;

export default class Steps extends React.Component {
  render() {
    return (
      <Container>
        {/* Header */}
        <Header></Header>
        {/* Switch de pasos*/}
        <StepsSwitch></StepsSwitch>
        {/* Footer */}
        <Footer></Footer>
      </Container>
    );
  }
}
